module.exports = __webpack_public_path__ + "img/temp_product03.520b6bfa.png";